/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReportExportFormats } from './ReportExportFormats';
import {
    ReportExportFormatsFromJSON,
    ReportExportFormatsFromJSONTyped,
    ReportExportFormatsToJSON,
    ReportExportFormatsToJSONTyped,
} from './ReportExportFormats';
import type { ReportResponseTypes } from './ReportResponseTypes';
import {
    ReportResponseTypesFromJSON,
    ReportResponseTypesFromJSONTyped,
    ReportResponseTypesToJSON,
    ReportResponseTypesToJSONTyped,
} from './ReportResponseTypes';
import type { ReportTypes } from './ReportTypes';
import {
    ReportTypesFromJSON,
    ReportTypesFromJSONTyped,
    ReportTypesToJSON,
    ReportTypesToJSONTyped,
} from './ReportTypes';

import { type BucketReportGeneratorRequest, BucketReportGeneratorRequestFromJSONTyped, BucketReportGeneratorRequestToJSON, BucketReportGeneratorRequestToJSONTyped } from './BucketReportGeneratorRequest';
import { type LinerInspectionReportGeneratorRequest, LinerInspectionReportGeneratorRequestFromJSONTyped, LinerInspectionReportGeneratorRequestToJSON, LinerInspectionReportGeneratorRequestToJSONTyped } from './LinerInspectionReportGeneratorRequest';
import { type UndercarriageReportGeneratorRequest, UndercarriageReportGeneratorRequestFromJSONTyped, UndercarriageReportGeneratorRequestToJSON, UndercarriageReportGeneratorRequestToJSONTyped } from './UndercarriageReportGeneratorRequest';
/**
 * 
 * @export
 * @interface ReportGeneratorRequest
 */
export interface ReportGeneratorRequest {
    /**
     * 
     * @type {number}
     * @memberof ReportGeneratorRequest
     */
    entityId?: number;
    /**
     * 
     * @type {Array<ReportExportFormats>}
     * @memberof ReportGeneratorRequest
     */
    exportFormats?: Array<ReportExportFormats>;
    /**
     * 
     * @type {ReportTypes}
     * @memberof ReportGeneratorRequest
     */
    reportType?: ReportTypes;
    /**
     * 
     * @type {ReportResponseTypes}
     * @memberof ReportGeneratorRequest
     */
    responseType?: ReportResponseTypes;
    /**
     * 
     * @type {boolean}
     * @memberof ReportGeneratorRequest
     */
    generateReport?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ReportGeneratorRequest
     */
    $type: string;
}



/**
 * Check if a given object implements the ReportGeneratorRequest interface.
 */
export function instanceOfReportGeneratorRequest(value: object): value is ReportGeneratorRequest {
    if (!('$type' in value) || value['$type'] === undefined) return false;
    return true;
}

export function ReportGeneratorRequestFromJSON(json: any): ReportGeneratorRequest {
    return ReportGeneratorRequestFromJSONTyped(json, false);
}

export function ReportGeneratorRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportGeneratorRequest {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
        if (json['$type'] === 'BucketInspection') {
            return BucketReportGeneratorRequestFromJSONTyped(json, ignoreDiscriminator);
        }
        if (json['$type'] === 'LinerInspection') {
            return LinerInspectionReportGeneratorRequestFromJSONTyped(json, ignoreDiscriminator);
        }
        if (json['$type'] === 'UndercarriageInspection') {
            return UndercarriageReportGeneratorRequestFromJSONTyped(json, ignoreDiscriminator);
        }
    }
    return {
        
        'entityId': json['entityId'] == null ? undefined : json['entityId'],
        'exportFormats': json['exportFormats'] == null ? undefined : ((json['exportFormats'] as Array<any>).map(ReportExportFormatsFromJSON)),
        'reportType': json['reportType'] == null ? undefined : ReportTypesFromJSON(json['reportType']),
        'responseType': json['responseType'] == null ? undefined : ReportResponseTypesFromJSON(json['responseType']),
        'generateReport': json['generateReport'] == null ? undefined : json['generateReport'],
        '$type': json['$type'],
    };
}

export function ReportGeneratorRequestToJSON(json: any): ReportGeneratorRequest {
    return ReportGeneratorRequestToJSONTyped(json, false);
}

export function ReportGeneratorRequestToJSONTyped(value?: ReportGeneratorRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (!ignoreDiscriminator) {
        switch (value['$type']) {
            case 'BucketInspection':
                return BucketReportGeneratorRequestToJSONTyped(value as BucketReportGeneratorRequest, ignoreDiscriminator);
            case 'LinerInspection':
                return LinerInspectionReportGeneratorRequestToJSONTyped(value as LinerInspectionReportGeneratorRequest, ignoreDiscriminator);
            case 'UndercarriageInspection':
                return UndercarriageReportGeneratorRequestToJSONTyped(value as UndercarriageReportGeneratorRequest, ignoreDiscriminator);
            default:
                return value;
        }
    }

    return {
        
        'entityId': value['entityId'],
        'exportFormats': value['exportFormats'] == null ? undefined : ((value['exportFormats'] as Array<any>).map(ReportExportFormatsToJSON)),
        'reportType': ReportTypesToJSON(value['reportType']),
        'responseType': ReportResponseTypesToJSON(value['responseType']),
        'generateReport': value['generateReport'],
        '$type': value['$type'],
    };
}

